export const isUndefined = (value: any) => value === undefined;

export const isDefined = (value: any) => !isUndefined(value);

export const isNull = (value: any) => value === null;

export const isNotNull = (value: any) => !isNull(value);

export const isNotNullOrUndefined = (value: any) => !(isUndefined(value) || isNull(value));

export const isString = (value: any) => typeof value === 'string';

export const isNonEmptyString = (value: any) => isString(value) && value !== '';

export const isEmptyString = (value: any) => value === '';

export const isEmptyStringOrNull = (value: any) => isEmptyString(value) || value === null;

export const trimToNull = (value?: string | null) => value?.trim() || null;

export const isEmptyArray = (value: any) => Array.isArray(value) && value.length === 0;

export const isEmptyArrayOrNull = (value: any) => isEmptyArray(value) || value === null;

export const isNumeric = (value: any) => !isNaN(parseFloat(value)) && isFinite(value);

export const range = (n: number, step?: number, start?: number) =>
  [...Array(n).keys()].map((i) => i + (start ?? 0)).filter((i) => !step || i % step === 0);

export const extractInteger = (value: string) => {
  const extracted = (value.match(/\d+/g) ?? [])[0];
  return extracted !== undefined ? parseInt(extracted) : undefined;
};

export const escapeHtml = (value: string) =>
  value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
